import clsx from "clsx"
import React from "react"
import { useController } from "react-hook-form"
import { FormInputProps } from "."

interface TextFieldProps extends FormInputProps {
  type?: React.HTMLInputTypeAttribute
  isShrink?: boolean
  multiline?: boolean
  minRows?: any
}

export function TextField({
  control,
  name,
  label,
  placeHolder,
  type = "text",
  minRows,
  multiline,
}: TextFieldProps) {
  const { field, fieldState } = useController({ name, control })
  const { error } = fieldState

  return (
    <div className="w-full">
      <label className="text-gray-8e sm:text-sm text-xxs">{label} </label>
      <input
        {...(minRows && { minRows: minRows })}
        {...(multiline && { multiline: multiline })}
        {...field}
        placeholder={placeHolder}
        className={clsx(
          "border-b sm:p-2 w-full focus:outline-0 text-sm md:text-base",
          error ? "border-red text-red" : "border-gray-8e text-black",
          "sm-only:text-xs py-2"
        )}
        type={type}
      />
      <small className="text-red">{error?.message}</small>
    </div>
  )
}
